import { Group, Pagination, Select, Skeleton, Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useAlbums } from '~/api/queries'
import { AlbumGrid } from '~/components/blocks/AlbumGrid/AlbumGrid'

export const Route = createFileRoute('/_app/albums/')({
  component: AlbumsPage,
})

const sortOptions = [
  { value: 'alphabetical', label: 'A-Z' },
  { value: 'newest', label: 'Newest' },
  { value: 'recent', label: 'Recently Played' },
  { value: 'frequent', label: 'Most Played' },
  { value: 'random', label: 'Random' },
]

function AlbumsPage() {
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState('alphabetical')
  const limit = 30
  const { data, isLoading } = useAlbums({ sort, limit, offset: (page - 1) * limit })

  const totalPages = data ? Math.ceil(data.total / limit) : 0

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Albums</Title>
        <Select
          data={sortOptions}
          value={sort}
          onChange={(v) => {
            setSort(v || 'alphabetical')
            setPage(1)
          }}
          w={180}
        />
      </Group>

      {isLoading ? <Skeleton h={400} /> : data?.data ? <AlbumGrid albums={data.data} /> : null}

      {totalPages > 1 && (
        <Group justify="center">
          <Pagination value={page} onChange={setPage} total={totalPages} />
        </Group>
      )}
    </Stack>
  )
}
